import React from 'react';
import { Box } from '@mui/material';
import ProCrownButton from './ProCrownButton';

const ProLockedSection = ({ locked, children, sx }) => {
  if (!locked) {
    return children;
  }

  return (
    <Box sx={{ position: 'relative', ...sx }}>
      <Box sx={{ opacity: 0.58, pointerEvents: 'none', userSelect: 'none' }}>
        {children}
      </Box>
      <Box sx={{ position: 'absolute', top: 4, right: 4, zIndex: 1 }}>
        <ProCrownButton locked />
      </Box>
    </Box>
  );
};

export default ProLockedSection;
